module.exports = __webpack_public_path__ + "static/media/Ukulele Song.a1540852.mp3";